import { ConversationProps } from '../Conversation';
import CallContent from './CallContent';
import DefaultContent from './DefaultContent';

type ConversationContentProps = Omit<ConversationProps, 'showAvatar'>;

export default function ConversationContent(props: ConversationContentProps) {
    const { conversation } = props;
    const isCallConversation = Boolean(conversation.call);

    return isCallConversation ? <CallContent conversation={conversation} /> : <DefaultContent {...props} />;
}

export { CallContent, DefaultContent, type ConversationContentProps };
